export { Heading2 } from "./Heading2";
